module.exports = __webpack_public_path__ + "img/close-btn.9f1cda3b.svg";